export default {

  addToCrops(crop) {
    return env.API.post(`/user/crop/makePersonal/${crop}`);
  },

  extendBaseCrop(data) {
    return env.API.post('/user/crop/add', data);
  },

  createCropVariety(data) {
    return env.API.post('/user/crop/variety', data);
  },

  createCropGrowingMethod(data) {
    return env.API.post('/user/crop/method', data);
  },

  createYieldGoal(data) {
    return env.API.post('/user/crop/goal', data);
  },

  createCropStage(data) {
    return env.API.post('/user/crop/stage', data);
  },


  // GETTERS

  getCropsByFilter(data) {
    return env.API.post('/crop/select', data);
  },

  getUserCrops(data) {
    return env.API.post('/user/crop/getPersonal', data);
  },

  getAllCrops(params) {
    return env.API.post('/user/crop/getAll', params);
  },

  getBaseCrop(id) {
    return env.API.post('/user/crop/getInfoByBase', {
      baseCropId: id,
    });
  },

  getInfoByVariety(id) {
    return env.API.post('/user/crop/getInfoByVariety', {
      varietyId: id,
    });
  },

  getInfoByMethod(id) {
    return env.API.post('/user/crop/getInfoByMethod', {
      methodId: id,
    });
  },

  getInfoByGoal(id) {
    return env.API.post('/user/crop/getInfoByGoal', {
      goalId: id,
    });
  },


  // OLD --------


  getCropVarieties(id) {
    return env.API.get('/user/crop/variety/parent/' + id);
  },

  getCropGrowingMethods(id) {
    return env.API.get('/user/crop/method/parent/' + id);
  },

  getYieldGoals(id) {
    return env.API.get('/user/crop/goal/parent/' + id);
  },

  getCropStages(yield_id) {
    return env.API.get('/user/crop/stages/parent/' + yield_id);
  },

  // REMOVE

  deleteBaseCrop(id) {
    return env.API.delete('/user/crop/base/' + id);
  },

  deleteUserCrop(id){
    return env.API.delete('/user/crop/userCrop/' + id);
  },

  deleteCropVariety(id) {
    return env.API.delete('/user/crop/variety/' + id);
  },

  deleteCropGrowingMethod(id) {
    return env.API.delete('/user/crop/method/' + id);
  },

  deleteYieldGoal(id) {
    return env.API.delete('/user/crop/goal/' + id);
  },

  deleteCropStage(id) {
    return env.API.delete('/user/crop/stage/' + id);
  },


  // EDIT

  updateBaseCrop(id, data) {
    return env.API.put('/user/crop/base/' + id, data);
  },

  updateCropVariety(id, data) {
    return env.API.put('/user/crop/variety/' + id, data);
  },

  updateCropGrowingMethod(id, data) {
    return env.API.put('/user/crop/method/' + id, data);
  },

  updateYieldGoal(id, data) {
    return env.API.put('/user/crop/goal/' + id, data);
  },

  updateCropStage(id, data) {
    return env.API.put('/user/crop/stage/' + id, data);
  },
}
